import {ComponentPropsWithoutRef, ElementType, ReactNode} from 'react'
import {TypographyVariant, variantMapping} from './TypographyType'
import './TypographyV2.scss'

export type TypographyProps<T extends ElementType = 'p'> = {
    children?: ReactNode,
    className?: string,
    title?: string,
    variant?: TypographyVariant,
    component?: T
} & ComponentPropsWithoutRef<T>

export const Typography = <T extends ElementType = 'p'>({
                                                            children,
                                                            className = '',
                                                            title,
                                                            variant = 'body-medium',
                                                            component,
                                                            ...props
                                                        }: TypographyProps<T>) => {
    const Component = component || variantMapping[variant]
    return <Component {...props} className={`datx-typography datx-${variant} ${className}`}>
        {title}
        {children}
    </Component>
}